import { Select2Helper } from "../../Helpers/Select2Helper";
import { StringHelper } from "../../Helpers/StringHelper";

export class FinishTaskPopupManager {

    constructor(private containerElement: JQuery) { }

    private setAsFinishedSwitch : JQuery<HTMLElement>;
    private progressSolutionLabel : JQuery<HTMLElement>;

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.setAsFinishedSwitch = self.containerElement.find('#set-as-finished-switch');

        self.progressSolutionLabel = self.containerElement.find('#progress-solutions-label');
    }

    private bindEvents() {
        var self = this;

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);
            form.trigger('submit');
        }) 

        self.setAsFinishedSwitch.off('change').on('change', () => {
            var checked = self.setAsFinishedSwitch.is(':checked');

            if(checked) {
                self.progressSolutionLabel.text("Solution");
            }
            else {
                self.progressSolutionLabel.text("Progress");
            }
        })
    }
}